export default "__VITE_ASSET__s8LmsOp2__"